import numeral from 'numeral';
import moment from 'moment-timezone';
import { capitalCase } from 'change-case';

export function number(value) {
  return numeral(value).format('0,0[.]00');
}

// Note: numeral multiplies the passed value by 100 when using percentage format
export function percent(value) {
  return numeral(value).format('0%');
}

export function toLower(value = '') {
  if (typeof value === 'string') {
    return value.toLowerCase();
  }

  return value;
}

export function capitalize(value = '') {
  return capitalCase(value);
}

export function dashIfEmpty(value) {
  if (value === null) {
    return '-';
  }
  if (Array.isArray(value) && value.length === 0) {
    return '-';
  }
  return value || '-';
}

export function date(value, format = 'YYYY-MM-DD') {
  return moment(value).format(format);
}

export function isEmpty(value) {
  return value === 0 || value.length === 0;
}

export function messageIfEmpty(value, message) {
  return isEmpty(value) && message;
}

export function dateTimezone(value, format = 'YYYY-MM-DD', timezone = null) {
  if (timezone) {
    return moment(value).tz(timezone).format(format);
  }

  return date(value, format);
}

export function localeDateShort(value = '', fromFormat = 'DD/MM/YY', toFormat = 'll') {
  return moment(value, fromFormat).format(toFormat);
}

export function englishNameFromLanguageId(languageId, languages) {
  const COURSE_DEFAULT_LANGUAGE = 'English';

  if (!languageId) {
    return COURSE_DEFAULT_LANGUAGE;
  }

  const language = languages.find(lang => lang.language_id === languageId);

  return language ? language.english_name : COURSE_DEFAULT_LANGUAGE;
}

export const getName = (value = {}) => {
  if (value === null) {
    return null;
  }
  return value.name || null;
};

export const time = value => {
  const minutesTotal = Number.parseInt(value, 10);
  const hours = Math.floor(minutesTotal / 60);
  const minutes = minutesTotal - hours * 60;

  if (hours > 0) {
    const formattedHours = `${hours}h`;
    const formattedMinutes = minutes > 0 ? ` ${minutes}m` : '';

    return `${formattedHours}${formattedMinutes}`;
  }

  if (minutes > 0) {
    return `${minutes}m`;
  }

  return '0';
};

export default {
  number,
  percent,
  toLower,
  date,
  localeDateShort,
  dashIfEmpty,
  getName,
};
